export function offsetToString(offset: number): string {
  const hours = Math.floor(offset / 60);
  const minutes = offset % 60;
  const offsetString = `${offset === 0 ? "" : offset < 0 ? "-" : "+"}${
    hours < 10 ? `0${hours}` : hours
  }:${minutes < 10 ? `0${minutes}` : minutes}`;

  return offsetString;
}
